/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

import Swiper from 'swiper';
import 'swiper/css';
import './style.scss';
import { setAllToMaxHeight } from '../../helper.js';

document.addEventListener('DOMContentLoaded', () => {
    const facetWrapper = document.querySelector('.facetwp-facet-product_selector');
    const recipeSliders = document.querySelectorAll('.recipe-slider');
    recipeSliders.forEach(recipeSlider => {
        new Swiper(recipeSlider.querySelector('.swiper'), {
            initialSlide: 1,
            slidesPerView: 1.5,
            spaceBetween:15,
            loop:true,
            breakpoints:{
                600: {
                    slidesPerView: 2,
                    spaceBetween: 50,
                    centeredSlides: true
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 50,
                  centeredSlides: true
              }
            }
        });
        const footers = recipeSlider.querySelectorAll('.footer');
        setAllToMaxHeight(footers);
        window.addEventListener('resize', ()=> {
            setAllToMaxHeight(footers);
        })
        filterRecipeCardsByParam();
    })

    if(facetWrapper){
        console.log(facetWrapper);
        const observer = new MutationObserver((mutationsList) => {
            mutationsList.forEach((mutation) => {
              // If the class attribute changed
              if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                // Check if the wrapper gained 'is-loading'
                if (facetWrapper.classList.contains('is-loading')) {
                  filterRecipeCardsByParam();
                }
              }
            });
        });
        observer.observe(facetWrapper, {
            attributes: true,         // Watch attributes
            attributeFilter: ['class'] // Only watch the 'class' attribute
        });
        console.log(observer);
    }
});


function filterRecipeCardsByParam() {
    console.log('filterRecipeCardsByParam s');
    const params = new URLSearchParams(window.location.search);
    const productSelector = params.get('_product_selector');
    const recipeCards = document.querySelectorAll('.recipe-slider .recipe-card');

    console.log(productSelector);
  
    if (productSelector) {
      console.log('fired');
      recipeCards.forEach((card) => {
        console.log(card.dataset.term);
        if (card.dataset.term === productSelector) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });
    } else {
      recipeCards.forEach((card) => {
        card.style.display = '';
      });
    }
  }